// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/set_project_image_description.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/set_project_image_description.proto.
 */
export const file_vision_assets_v1_set_project_image_description: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vYXNzZXRzL3YxL3NldF9wcm9qZWN0X2ltYWdlX2Rlc2NyaXB0aW9uLnByb3RvEhdwcm90b3MudmlzaW9uLmFzc2V0cy52MSK7AQohU2V0UHJvamVjdEltYWdlRGVzY3JpcHRpb25SZXF1ZXN0ElEKBnBhcmFtcxgBIAEoCzJBLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlNldFByb2plY3RJbWFnZURlc2NyaXB0aW9uUmVxdWVzdC5QYXJhbXMaQwoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEAoIaW1hZ2VfaWQYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkiggEKIlNldFByb2plY3RJbWFnZURlc2NyaXB0aW9uUmVzcG9uc2USUgoGcmVzdWx0GAEgASgLMkIucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuU2V0UHJvamVjdEltYWdlRGVzY3JpcHRpb25SZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageDescriptionRequest
 */
export type SetProjectImageDescriptionRequest = Message<"protos.vision.assets.v1.SetProjectImageDescriptionRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetProjectImageDescriptionRequest.Params params = 1;
   */
  params?: SetProjectImageDescriptionRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageDescriptionRequest.
 * Use `create(SetProjectImageDescriptionRequestSchema)` to create a new message.
 */
export const SetProjectImageDescriptionRequestSchema: GenMessage<SetProjectImageDescriptionRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_description, 0);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageDescriptionRequest.Params
 */
export type SetProjectImageDescriptionRequest_Params = Message<"protos.vision.assets.v1.SetProjectImageDescriptionRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageDescriptionRequest.Params.
 * Use `create(SetProjectImageDescriptionRequest_ParamsSchema)` to create a new message.
 */
export const SetProjectImageDescriptionRequest_ParamsSchema: GenMessage<SetProjectImageDescriptionRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_description, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageDescriptionResponse
 */
export type SetProjectImageDescriptionResponse = Message<"protos.vision.assets.v1.SetProjectImageDescriptionResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.SetProjectImageDescriptionResponse.Result result = 1;
   */
  result?: SetProjectImageDescriptionResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageDescriptionResponse.
 * Use `create(SetProjectImageDescriptionResponseSchema)` to create a new message.
 */
export const SetProjectImageDescriptionResponseSchema: GenMessage<SetProjectImageDescriptionResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_description, 1);

/**
 * @generated from message protos.vision.assets.v1.SetProjectImageDescriptionResponse.Result
 */
export type SetProjectImageDescriptionResponse_Result = Message<"protos.vision.assets.v1.SetProjectImageDescriptionResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.SetProjectImageDescriptionResponse.Result.
 * Use `create(SetProjectImageDescriptionResponse_ResultSchema)` to create a new message.
 */
export const SetProjectImageDescriptionResponse_ResultSchema: GenMessage<SetProjectImageDescriptionResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_set_project_image_description, 1, 0);

